module.exports = __webpack_public_path__ + "static/img/ubg3.731000d7.png";